import React from 'react';
import { Modal, Input, Form, DatePicker } from 'antd';
import moment from 'moment';
import global from '../../../common/utility/global';
import { FORMAT_2DECIMALS, GREATER_THAN_ZERO } from '../../../common/types/regularExpresionType';

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    nombre: values.nombre,
                    numero: values.numero,
                    fechaInicioStr: values.fechaInicioStr.format('DD/MM/YYYY'),
                    fechaFinStr: values.fechaFinStr.format('DD/MM/YYYY'),
                    costoUnitario: parseFloat(values.costoUnitario),
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    fechaFinCustomValidation = (rule, value, callback) => {
        var fechaInicio = this.props.form.getFieldValue('fechaInicioStr').toDate();
        var fechaFin = value.toDate();
        if (fechaInicio > fechaFin)
            callback('La fecha fin debe ser mayor o igual que la fecha de inicio.');
        callback();
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Proyecto" : "Modificar Proyecto"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Codigo Proyecto">
                                {getFieldDecorator('numero', {
                                    initialValue: this.props.formValues.numero,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Codigo"
                                        autoComplete="off"
                                        maxLength={10}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Fecha Inicio">
                                {getFieldDecorator('fechaInicioStr', {
                                    initialValue: moment(this.props.formValues.fechaInicioStr, 'DD/MM/YYYY'),
                                    rules: [{
                                        type: 'object',
                                        required: true,
                                        message: 'Campo obligatorio.'
                                    }],
                                })(
                                    <DatePicker
                                        placeholder="Seleccione Fecha Inicio"
                                        format="DD/MM/YYYY"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Fecha Fin">
                                {getFieldDecorator('fechaFinStr', {
                                    initialValue: moment(this.props.formValues.fechaFinStr, 'DD/MM/YYYY'),
                                    rules: [
                                        {
                                            type: 'object',
                                            required: true,
                                            message: 'Campo obligatorio.'
                                        },
                                        {
                                            validator: this.fechaFinCustomValidation
                                        }
                                    ],
                                })(
                                    <DatePicker
                                        placeholder="Seleccione Fin Inicio"
                                        format="DD/MM/YYYY"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Costo Proyecto">
                                {getFieldDecorator('costoUnitario', {
                                    initialValue: parseFloat(this.props.formValues.costoUnitario).toFixed(2),
                                    rules: [
                                        {
                                            required: false,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }
                                      
                                    ]
                                })(
                                    <Input
                                        className="text-right"
                                        placeholder="Ingresar Costo"
                                        autoComplete="off"
                                        onKeyPress={global.onKeyPressDecimals}
                                        onBlur={(e) => {
                                            this.props.form.setFieldsValue({
                                                costoUnitario: global.onBlurDecimals(e, 2)
                                            });
                                        }}
                                        
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)